"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = require("@cian/config/browser");
var wordsCase_1 = require("../../../shared/wordsCase");
var getBaseServiceUri = function (microserviceName, projectName, hostType) {
    if (hostType === void 0) { hostType = 'api'; }
    var config = browser_1.getConfig();
    var hostPart = hostType === 'ud-api' ? 'udApiBrowserUrl' : 'browserUrl';
    var baseServiceUri = config.get(microserviceName + "." + hostPart);
    if (baseServiceUri) {
        return baseServiceUri;
    }
    var microserviceNameCamelCase = wordsCase_1.WordsCaseService.kebabCaseToCamelCase(microserviceName);
    baseServiceUri = config.get(microserviceNameCamelCase + "." + hostPart);
    if (baseServiceUri) {
        return baseServiceUri;
    }
    var mcsRunEnv = config.get('web.mcsRunEnv') || 'PROD';
    var microserviceNameKebabCase = wordsCase_1.WordsCaseService.camelCaseToKebabCase(microserviceName);
    switch (mcsRunEnv) {
        case 'DEV':
            return "http://master." + microserviceNameKebabCase + ".dev3.cian.ru/";
        case 'PROD':
            return "https://" + hostType + ".cian.ru/" + microserviceNameKebabCase + "/";
        default:
            return "https://" + mcsRunEnv.replace('-', '') + ".api.stage.cian.ru/" + microserviceNameKebabCase + "/";
    }
};
exports.getBaseServiceUri = getBaseServiceUri;
//# sourceMappingURL=baseServiceUri.js.map